import { Link } from "react-router-dom";
import { seoIntro } from "@/mocks/seoContent";

export default function SEOSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative rounded-[32px] overflow-hidden h-[360px] md:h-[460px] w-full shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Colorful%20stack%20of%20branded%20shoe%20boxes%20with%20peeking%20sneaker%20tops%20arranged%20like%20a%20city%20skyline%20vibrant%20playful%20photography%20with%20each%20box%20in%20different%20color%20creative%20product%20display%20cheerful%20editorial%20style%20warm%20natural%20lighting%20clean%20white%20background%20high%20detail&width=1000&height=1300&seq=seo-section-img-v2&orientation=portrait"
                alt="Pandabuy spreadsheet curated fashion finds"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-5 left-5 px-4 py-2 rounded-lg bg-background-50/80 backdrop-blur-sm border border-background-200/40">
                <span className="text-xs font-semibold text-foreground-800">SEO Guide 2026</span>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="inline-block px-3 py-1.5 rounded-lg bg-primary-100/70 text-primary-800 text-xs font-semibold mb-4">
              {seoIntro.tag}
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.12] text-balance">
              {seoIntro.title}
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              {seoIntro.description}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-7">
              <Link
                to={seoIntro.articlePath}
                className="px-5 py-3 rounded-xl bg-background-100 border border-background-200/70 text-foreground-800 text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-between gap-3"
              >
                <span>{seoIntro.buttonText}</span>
                <i className="ri-arrow-right-up-line text-lg"></i>
              </Link>
              <a
                href={seoIntro.mainSiteLink}
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-3 rounded-xl text-foreground-600 text-sm font-medium hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 self-center"
              >
                Visit Main Store
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}